<script>
import { required } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ManagementUserProfilesManage',

  components: {
    Modal: () => import('@/components/general/Modal'),
    InputField: () => import('@/components/general/InputField'),
    Action: () => import('@/components/general/Action'),
    SelectField: () => import('@/components/general/SelectField')
  },

  data () {
    return {
      partnersListOptions: [],
      formData: {
        id: null,
        name: null,
        partnerId: null,
        permissions: {
          solution: null,
          tracks: null,
          programs: null,
          // themes: null,
          sessions: null,
          session_attendance: null,
          users: null,
          enrollment: null,
          entrepreneur_profiles: null,
          profiles: null,
          solution_themes: null,
          surveys: null,
          certificates: null,
          banners: null,
          gamification: null,
          reports: null,
          reports_students: null,
          reports_enrollments: null,
          reports_surveys_answers: null,
          reports_canvas_discussion: null,
          reports_learning_path_resume: null,
          reports_solutions_resume: null,
          reports_rae_services: null,
          reports_solution_alerts: null,
          reports_sas_events: null,
          reports_financial: null,
          reports_comments: null,
          configurations: null,
          dashboard: null,
          impersonate: null,
          search_engine: null,
          notification: null,
          thematic_pages: null,
          filters: null,
          mediation_plans: null,
          comments: null,
          tools: null,
          partners: null,
          articles: null
        }
      },

      basicOptions: [
        {
          label: this.$t('management.user.profiles:modal.form.permissions.view'),
          value: 'view'
        },
        {
          label: this.$t('management.user.profiles:modal.form.permissions.add.edit'),
          value: 'add.edit'
        },
        {
          label: this.$t('management.user.profiles:modal.form.permissions.disable'),
          value: 'disable'
        }
      ],

      dashboardOptions: [
        {
          label: this.$t('management.user.profiles:modal.form.permissions.view'),
          value: 'view'
        },
        {
          label: this.$t('management.user.profiles:modal.form.permissions.disable'),
          value: 'disable'
        }
      ],

      searchEngineOptions: [
        {
          label: this.$t('management.user.profiles:modal.form.permissions.add.edit'),
          value: 'add.edit'
        },
        {
          label: this.$t('management.user.profiles:modal.form.permissions.disable'),
          value: 'disable'
        }
      ],

      impersonateOptions: [
        {
          label: this.$t('management.user.profiles:modal.form.permissions.view'),
          value: 'view'
        },
        {
          label: this.$t('management.user.profiles:modal.form.permissions.disable'),
          value: 'disable'
        }
      ]
    }
  },

  validations: {
    formData: {
      name: {
        required
      },

      permissions: {
        solution: {
          required
        },

        tracks: {
          required
        },

        programs: {
          required
        },

        sessions: {
          required
        },

        session_attendance: {
          required
        },

        users: {
          required
        },

        enrollment: {
          required
        },

        entrepreneur_profiles: {
          required
        },

        profiles: {
          required
        },

        solution_themes: {
          required
        },

        surveys: {
          required
        },

        certificates: {
          required
        },

        banners: {
          required
        },

        gamification: {
          required
        },

        reports: {
          required
        },

        reports_students: {
          required
        },

        reports_enrollments: {
          required
        },

        reports_surveys_answers: {
          required
        },

        reports_canvas_discussion: {
          required
        },

        reports_learning_path_resume: {
          required
        },

        reports_solutions_resume: {
          required
        },

        reports_rae_services: {
          required
        },

        reports_solution_alerts: {
          required
        },

        reports_sas_events: {
          required
        },

        reports_financial: {
          required
        },

        reports_comments: {
          required
        },

        configurations: {
          required
        },

        dashboard: {
          required
        },

        search_engine: {
          required
        },

        impersonate: {
          required
        },

        notification: {
          required
        },

        thematic_pages: {
          required
        },

        filters: {
          required
        },

        mediation_plans: {
          required
        },

        comments: {
          required
        },

        tools: {
          required
        },

        partners: {
          required
        },

        articles: {
          required
        }
      }
    }
  },

  computed: {
    ...mapState([ 'fetching' ]),

    isEditing () {
      return !!this.$route.params.id
    },

    title () {
      if (this.isEditing) {
        return this.$t('management.user.profiles:modal.title.editing')
      }

      return this.$t('management.user.profiles:modal.title.add')
    },

    allOptions () {
      return this.basicOptions
    },

    sections () {
      return [
        {
          tag: 'solution'
        },
        {
          tag: 'tracks'
        },
        {
          tag: 'programs'
        },
        // {
        //   tag: 'themes'
        // },
        {
          tag: 'sessions'
        },
        {
          tag: 'session_attendance'
        },
        {
          tag: 'users'
        },
        {
          tag: 'enrollment'
        },
        {
          tag: 'entrepreneur_profiles'
        },
        {
          tag: 'profiles'
        },
        {
          tag: 'solution_themes'
        },
        {
          tag: 'surveys'
        },
        {
          tag: 'certificates'
        },
        {
          tag: 'banners'
        },
        {
          tag: 'gamification'
        },
        {
          tag: 'reports'
        },
        {
          tag: 'reports_students'
        },
        {
          tag: 'reports_enrollments'
        },
        {
          tag: 'reports_surveys_answers'
        },
        {
          tag: 'reports_canvas_discussion'
        },
        {
          tag: 'reports_learning_path_resume'
        },
        {
          tag: 'reports_solutions_resume'
        },
        {
          tag: 'reports_rae_services'
        },
        {
          tag: 'reports_solution_alerts'
        },
        {
          tag: 'reports_sas_events'
        },
        {
          tag: 'reports_financial'
        },
        {
          tag: 'reports_comments'
        },
        {
          tag: 'configurations'
        },
        {
          tag: 'dashboard',
          items: this.dashboardOptions
        },
        {
          tag: 'search_engine',
          items: this.searchEngineOptions
        },
        {
          tag: 'impersonate',
          items: this.impersonateOptions
        },
        {
          tag: 'notification'
        },
        {
          tag: 'thematic_pages'
        },
        {
          tag: 'filters'
        },
        {
          tag: 'mediation_plans'
        },
        {
          tag: 'comments'
        },
        {
          tag: 'tools'
        },
        {
          tag: 'partners'
        },
        {
          tag: 'articles'
        }
      ]
    }
  },

  created () {
    this.loadPartnersList()

    if (this.isEditing) {
      this.setup()
    }
  },

  methods: {
    ...mapActions([
      'setFetching',
      'setFeedback',
      'attemptGetProfile',
      'attemptCreateProfile',
      'attemptUpdateProfile',
      'attemptGetLoggedUser',
      'attemptGetPartnersList'
    ]),

    loadPartnersList () {
      this.attemptGetPartnersList({
        page: 1,
        limit: 200
      }).then(pagination => {
        if (pagination && pagination.data) {
          this.partnersListOptions = pagination.data
            .map(p => ({
              text: p.name,
              value: p.id
            }))
            .sort((a, b) => a.text.localeCompare(b.text))
        }
      })
    },

    sectionAccepts (section, optionValue) {
      const items = section.items || this.basicOptions

      return items.some(item => item.value === optionValue)
    },

    formatFormData () {
      const formData = {
        id: this.formData.id,
        name: this.formData.name,
        partner_id: this.formData.partnerId || null,
        permissions: {}
      }

      for (const i in this.formData.permissions) {
        if (this.formData.permissions[i] === 'add.edit') {
          formData.permissions[i] = 'write'
        }

        if (this.formData.permissions[i] === 'view') {
          formData.permissions[i] = 'read'
        }
      }

      return formData
    },

    submitCreation () {
      this.setFetching(true)

      this.attemptCreateProfile(this.formatFormData()).then(() => {
        this.setFeedback({ message: this.$t('management.user.profile:feedback.created.success') })
        this.$router.push({ name: 'management.user.profiles' })
      }).catch(() => {
        this.setFeedback({ message: this.$t('management.user.profile:feedback.created.error') })
      }).finally(() => {
        this.setFetching(false)
      })
    },

    submitUpdate () {
      this.setFetching(true)

      this.attemptUpdateProfile(this.formatFormData()).then(() => {
        this.setFeedback({ message: this.$t('management.user.profile:feedback.update.success') })

        this.attemptGetLoggedUser().then(() => {
          this.$router.push({ name: 'management.user.profiles' })
        })
      }).catch(() => {
        this.setFeedback({ message: this.$t('management.user.profile:feedback.update.error') })
      }).finally(() => {
        this.setFetching(false)
      })
    },

    submit (next) {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.isEditing ? this.submitUpdate(next) : this.submitCreation(next)
      } else {
        this.setFeedback({ message: this.$t('management.user.profile:feedback.validation.error') })
      }
    },

    closeModal () {
      this.$router.push({ name: 'management.user.profiles' })
    },

    setup () {
      this.setFetching(true)

      this.attemptGetProfile(this.$route.params.id).then((data) => {
        this.formData = {
          ...data,
          partnerId: (data.partner && data.partner.id) || data.partnerId || data.partner_id || null
        }
      })
        .finally(() => {
          this.setFetching(false)
        })
    }
  }
}
</script>

<template>
  <Modal
    :active="!fetching"
    @close="closeModal"
  >
    <div class="modal-form modal-add-user modal-user-profile">
      <span class="modal-subtitle">{{ $t('management:modal.subtitle') }}</span>
      <h2 class="modal-title">
        {{ title }}
      </h2>
      <span class="modal-form-description">
        <strong>{{ $t('management.user.profiles:modal.description_bold') }}</strong>
        {{ $t('management.user.profiles:modal.description') }}
      </span>

      <form @submit.prevent="submit()">
        <InputField
          v-model="formData.name"
          dark
          :label="$t('management.user.profiles:modal.form.name')"
          :validation="$v.formData.name"
        />

        <SelectField
          v-model="formData.partnerId"
          dark
          :label="$t('global:form.thematicPages.partner')"
          :items="partnersListOptions"
        />

        <p class="form-group-title">
          {{ $t('management.user.profiles:modal.form.permissions') }}
        </p>

        <table class="permissions-matrix">
          <thead>
            <tr>
              <th class="permissions-matrix-context">
                {{ $t('management.user.profiles:modal.form.permissions.context') }}
              </th>
              <th
                v-for="option in allOptions"
                :key="option.value"
                class="permissions-matrix-option"
              >
                {{ option.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="section in sections"
              :key="section.tag"
              :class="{ 'has-error': $v.formData.permissions[section.tag] && $v.formData.permissions[section.tag].$error }"
            >
              <td class="permissions-matrix-context">
                {{ $t('management.user.profiles:modal.form.' + section.tag) }}
              </td>
              <td
                v-for="option in allOptions"
                :key="option.value"
                class="permissions-matrix-cell"
              >
                <label
                  v-if="sectionAccepts(section, option.value)"
                  class="permissions-matrix-radio"
                  :class="{ 'is-checked': formData.permissions[section.tag] === option.value }"
                >
                  <input
                    v-model="formData.permissions[section.tag]"
                    type="radio"
                    :name="`perm-${section.tag}`"
                    :value="option.value"
                  >
                  <span class="permissions-matrix-radio-dot" />
                </label>
                <span
                  v-else
                  class="permissions-matrix-na"
                >—</span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="form-submit text-center">
          <Action
            type="button"
            secondary
            large
            submit
            fixed-width
            :text="$t('global:form.save')"
          />
        </div>
      </form>
    </div>
  </Modal>
</template>

<style>

.modal-user-profile form {
  max-width: 720px;
}

.modal-user-profile form > .form-item {
  max-width: 520px;
  margin-left: auto;
  margin-right: auto;
}

.form-group-title {
  font-family: 'Lato';
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  margin-top: 48px;
  margin-bottom: 20px;
}

.permissions-matrix {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  font-family: 'Roboto', sans-serif;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 32px;
}

.permissions-matrix th {

  position: sticky;
  top: 0;
  z-index: 2;
  text-align: center;
  font-size: 1.6em;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  /* bg sólido necessário para sticky cobrir o conteúdo passando por baixo */
  background: #2e3d65;
  padding: 14px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
}

.permissions-matrix th.permissions-matrix-context {
  text-align: left;
  padding-left: 16px;
}

.permissions-matrix tbody tr {
  transition: background-color 150ms ease;
}

.permissions-matrix tbody tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

.permissions-matrix tbody tr.has-error {
  background: rgba(230, 72, 72, 0.08);
}

.permissions-matrix td {
  font-size: 1.6em;
  padding: 10px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  text-align: center;
}

.permissions-matrix tbody tr:last-child td {
  border-bottom: 0;
}

.permissions-matrix td.permissions-matrix-context {
  text-align: left;
  font-weight: 500;
  color: #fff;
  padding-left: 16px;
  white-space: nowrap;
}

.permissions-matrix-cell {
  width: 110px;
}

/* Custom radio (substitui o input radio nativo) */
.permissions-matrix-radio {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  transition: background-color 150ms ease;
}

.permissions-matrix-radio:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.permissions-matrix-radio input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.permissions-matrix-radio-dot {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  background: transparent;
  transition: border-color 150ms ease, background-color 150ms ease;
  box-sizing: border-box;
}

.permissions-matrix-radio.is-checked .permissions-matrix-radio-dot {
  border-color: #fff;
  background: #fff;
  box-shadow: inset 0 0 0 3px #263457;
}

.permissions-matrix-radio:focus-within {
  outline: 2px solid rgba(255, 255, 255, 0.6);
  outline-offset: 2px;
}

.permissions-matrix-na {
  display: inline-block;
  color: rgba(255, 255, 255, 0.2);
  font-size: 1.1em;
  user-select: none;
}
</style>
